export default {
  DEV: {
    index: 1,
    value: "dev"
  },
  MANAGER: {
    index: 2,
    value: "manager"
  },
  SHIPPER: {
    index: 3,
    value: "shipper"
  },
  TRANSPORTER: {
    index: 4,
    value: "transporter"
  },
  RISK_MANAGER: {
    index: 5,
    value: "risk_manager"
  },
  BROKER: {
    index: 6,
    value: "broker"
  },
  FINTECH: {
    index: 7,
    value: "fintech"
  },
  CUSTOMER: {
    index: 8,
    value: "customer"
  },
  FOUR_PL: {
    index: 9,
    value: "four_pl"
  },
  AUDITOR: {
    index: 10,
    value: "auditor"
  },
  FINANCE_MANAGER: {
    index: 11,
    value: "finance_manager"
  },
  TAKER: {
    index: 12,
    value: "taker"
  },
  SUPPLIER: {
    index: 14,
    value: "supplier"
  },
};
